<template>
  <div id="publications">
    <bread :content="breadContent"></bread>
    <p class="Page-title">出版著作</p>
    <el-divider></el-divider>
    <div class="container">
      <div class="book-line" v-for="(item, index) in bookData" :key="index">
        <el-divider v-if="index !== 0" class="separate-line"></el-divider>
        <book :data="subItem" v-for="(subItem, subIndex) in item" :key="subIndex"></book>
      </div>
    </div>
    <el-pagination class="page" background layout="prev,pager,next,jumper" :total="bookData.length" :page-size="20" :current-page="nowPage">
      <!-- @current-change="handleCurrentChange" -->
    </el-pagination>
  </div>
</template>

<script>
import bread from "@/components/bread";
import book from "@/components/studyResult/book";
import Api from "@/network.js";

export default {
  name: "publications",
  data() {
    return {
      nowPage: 1,
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "研究成果", routerName: "studyResult" },
        { text: "出版著作", routerName: "publications" }
      ],
      // 二维数组，其元素为长度为6的数组
      bookData: []
    };
  },
  components: {
    book,
    bread
  },
  methods: {
    setData(obj) {
      Object.assign(this.$data, obj);
    }
  },
  async beforeRouteEnter(to, from, next) {
    const res = (await Api.studyResult.getPublication()) || [];
    let data = [];
    res.forEach(item => {
      data.push({
        imgSrc: item.Cover,
        name: item.Title,
        author: item.Author
      });
    });
    let num=document.querySelector('html').clientWidth*0.8/190;//每行的数目
    data = data.split(parseInt(num))
    next(vm => vm.setData({ bookData: data }));
  }
};
</script>

<style lang="scss">
.book-line {
  .el-divider {
    position: absolute;
    top: -60px;
    width: calc(100% - 45px);
    margin: 0;
    opacity: .8;
  }
}
</style>

<style lang="scss" scoped>
#publications {
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
.container {
  display: flex;
  flex-wrap: wrap;
  .book-line {
    display: flex;
    position: relative;
    width: 100%;
  }
  .book {
    margin-right: 40px;
    margin-bottom: 120px;
  }
}
.page {
  width: 100%;
  transform: scale(1.3);
  text-align: center;
  margin-top: 50px;
}
</style>
